module.exports = "/fonts/gh-icons.eot?e4ea097744d959398b5e3b5d866b2953";